<div class="form-container flex flex-row full-grow-no-shrink-no-basis " >
  <div  class="orginal-document flex flex-col full-grow-no-shrink-no-basis ">
    <div class="header flex flex-row justify-start items-center">
      <div class="title full-grow-no-shrink-no-basis "  *ngIf="formModel && formModel.hasPreview">
        <span
          *ngIf="translationModel.toolName === translationToolNames.Translation || translationModel.toolName === translationToolNames.ConvertCurrency">Orginal Document <span
          *ngIf="formModel && formModel.hasPreview && formModel.languageText">({{formModel.languageText}})</span></span>
        <span *ngIf="translationModel.toolName === translationToolNames.Compare">{{formModel.fileName}}<span
          *ngIf="formModel && formModel.hasPreview && formModel.languageText">({{formModel.languageText}})</span></span>
      </div>

      <div class="button-container m-r-20 flex flex-row justify-start items-center"
           *ngIf="formModel && formModel.hasPreview">
        <span class="title">Page</span>
        <select [value]="formModel.currentPage" (change)="jumpToPage($event)" data-copilot="viewer-select-original-page">
          <option *ngFor="let page of formModel?.pages; let i =index;" [value]="i+1">{{i + 1}}</option>
        </select>
      </div>
    </div>
    <!--    <div class="navigaion-section" fxLayout="column" fxLayoutAlign="start center" >
          <div class="top p-20 w-p-100" fxLayoutAlign="space-between center" *ngIf="formModel && formModel.hasPreview">
            <div fxLayout="row" fxLayoutAlign="start center">
              <div class="title">
                <a class="link-color" (click)="onDownload()">{{formModel?.fileName}}</a>
              </div>
            </div>
            <div class="navigaion-panle" fxLayout="row" fxLayoutAlign="start center">
            </div>
          </div>
          <div class="top p-20 w-p-100" fxLayoutAlign="space-between center" *ngIf="formModel && !formModel.hasPreview">
            <div class="title">{{progressStatus.status}}<span *ngIf="progressStatus.percentage>0">: {{progressStatus.percentage}}%</span>
            </div>
          </div>
        </div>-->
    <div  class="flex flex-row full-grow-no-shrink-no-basis " *ngIf="iFrameContent !== null"
         data-copilot="viewer-original-document"
         [innerHTML]="iFrameContent  | sanitizeHtml">
    </div>
    <div  class="flex flex-row full-grow-no-shrink-no-basis " *ngIf="iFrameContent === null && progressStatus.message">
      {{progressStatus.message}}
    </div>
  </div>
</div>
